import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { maisIntegridade, mapa, sisbi } from "../../assets/images";
import {
  BannerText,
  BannerWrapper,
  BoxImageContainer,
  BoxImageMaisIntegridade,
  BoxImageMapa,
  BoxImageSisbi,
  BoxTextContainer,
  ButtonContatos,
  ContatosESelosContainer,
  EmblaSlide,
  EmblaSlideText,
  H2Carousel,
  HomeContainer,
  ImageCarousel,
  InfoContainerUm,
  PaginationButton,
  PaginationContainer,
} from "./styles";
import { legend } from "../../constants/legend_products";
import Footer from "../../components/footer";

const Products = () => {
  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = legend.slice(startIndex, endIndex);
  const navigate = useNavigate();
  const totalPages = Math.ceil(legend.length / itemsPerPage);

  const handleSlideClick = (item: any) => {
    navigate(`/products/${item.id}`);
  };

  return (
    <HomeContainer>
      <BannerWrapper>
        <BannerText>
          Nossos <br /> Produtos
        </BannerText>
      </BannerWrapper>

      <InfoContainerUm>
        {currentItems.map((item, index) => (
          <EmblaSlide
            key={startIndex + index}
            onClick={() => handleSlideClick(item)}
          >
            <ImageCarousel
              src={item.imagem[0]}
              alt={`Slide ${startIndex + index + 1}`}
            />
            <EmblaSlideText>
              <H2Carousel>
                {item.descricao} <span>{item.codigo}</span>
              </H2Carousel>
            </EmblaSlideText>
          </EmblaSlide>
        ))}
      </InfoContainerUm>

      {/* Paginação */}
      <PaginationContainer>
        <PaginationButton
          onClick={() => {
            setCurrentPage((prev) => Math.max(prev - 1, 1));
            window.scrollTo(0, 0);
          }}
          disabled={currentPage === 1}
        >
          Anterior
        </PaginationButton>

        {Array.from({ length: totalPages }, (_, i) => (
          <PaginationButton
            key={i}
            onClick={() => {
              setCurrentPage(i + 1);
              window.scrollTo(0, 0);
            }}
            active={currentPage === i + 1}
          >
            {i + 1}
          </PaginationButton>
        ))}

        <PaginationButton
          onClick={() => {
            setCurrentPage((prev) => Math.min(prev + 1, totalPages));
            window.scrollTo(0, 0);
          }}
          disabled={currentPage === totalPages}
        >
          Próximo
        </PaginationButton>
      </PaginationContainer>

      {/* Restante do seu código */}
      <ContatosESelosContainer>
        <BoxTextContainer>
          <div>
            <h2>Vamos fazer negócios?</h2>
            <p>Fale com um especialista</p>
          </div>
          <ButtonContatos
            onClick={() => {
              window.location.href = "/contact-us";
            }}
          >
            CONTATO
          </ButtonContatos>
        </BoxTextContainer>
        <BoxImageContainer>
          <BoxImageSisbi src={sisbi} alt="SISBI" />
          <BoxImageMaisIntegridade src={maisIntegridade} />
          <BoxImageMapa src={mapa} alt="Mapa" />
        </BoxImageContainer>
      </ContatosESelosContainer>
      <Footer />
    </HomeContainer>
  );
};

export default Products;
